module.exports = __webpack_public_path__ + "img/img4.791353b1.png";